import React from "react";
import { NotificationIcon } from "../../Icons";
import { Image } from "@learningblocks/shared-components/lib/Image";

export function DescriptionIcon() {
  return <Image alt="info" tabIndex={-1} src={NotificationIcon} />;
}
